<template>
  <div>
    <div class="patient-profile-box">
      <div class="box-title">
        {{ $t('text.patient_profile') }}
      </div>
      <div v-if="data" class="patient-profile-content">
        <el-button
          icon="el-icon-edit-outline"
          class="edit-button"
          type="primary"
          size="mini"
          circle
          :loading="fetchDetailLoading"
          v-if="p('Patients.Monitor.Edit')"
          @click="editPatient"
        ></el-button>
        <div class="section">
          <div class="section-title">{{ $t('text.group') }}</div>
          <div class="section-content">
            {{ $store.getters[`user/selecteOrganisationName`] }}
          </div>
        </div>
        <!-- <div class="section">
          <div class="section-title">{{ $t('text.room_number') }}</div>
          <div class="section-content">
            <div v-if="data.patientRoom">
              <div>
                {{ data.patientRoom.BuildingName }},
                {{ data.patientRoom.FloorName }},
                {{ data.patientRoom.RoomNumber }}
              </div>
            </div>
            <div v-else>--</div>
          </div>
        </div> -->
        <div class="section">
          <div class="section-title">{{ $t('text.periods') }}</div>
          <div class="section-content">
            <div>
              <span
                >{{ $t('text.day').toLowerCase() | firstLetterCapitalize }}:
              </span>
              <span
                >{{ data.patientProfile.DayStartTime }} -
                {{ data.patientProfile.DayEndTime }}
              </span>
              <span
                class="active-text"
                v-if="data.patientProfile.Time === timePeriod.day"
                >({{ $t('text.active') }})</span
              >
            </div>
            <div>
              <span
                >{{ $t('text.night').toLowerCase() | firstLetterCapitalize }}:
              </span>
              <span
                >{{ data.patientProfile.NightStartTime }} -
                {{ data.patientProfile.NightEndTime }}
              </span>
              <span
                class="active-text"
                v-if="data.patientProfile.Time === timePeriod.night"
                >({{ $t('text.active') }})</span
              >
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-title">{{ $t('text.products') }}</div>
          <div class="section-content">
            <div>
              <span
                >{{ $t('text.day').toLowerCase() | firstLetterCapitalize }}:
              </span>
              <span>{{ data.patientProfile.DayProduct || '--' }} </span>
              <span
                class="active-text"
                v-if="data.patientProfile.PadSelected === timePeriod.day"
                >({{ $t('text.active') }})</span
              >
            </div>
            <div>
              <span
                >{{ $t('text.night').toLowerCase() | firstLetterCapitalize }}:
              </span>
              <span>{{ data.patientProfile.NightProduct || '--' }} </span>
              <span
                class="active-text"
                v-if="data.patientProfile.PadSelected === timePeriod.night"
                >({{ $t('text.active') }})</span
              >
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-title">{{ $t('text.pod_serial_number') }}</div>
          <div class="section-content">
            {{ data.patientProfile.SerialNumber || '--' }}
          </div>
        </div>
        <div class="section">
          <div class="section-title">{{ $t('text.patient') }} ID</div>
          <div class="section-content">
            {{ data.patientProfile.Id || '--' }}
          </div>
        </div>
      </div>
      <div v-else v-loading="loading" class="no-data"></div>
      <EditPatient
        ref="editPatient"
        :shouldRedirectDashboard="false"
        :reFetchPatients="false"
        @saveSuccess="refreshData"
      />
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
import { timePeriod } from '../../const'
import EditPatient from '@/components/manage/patients/EditPatient.vue'

export default {
  data() {
    return {
      data: '',
      loading: false,
      timer: '',
      timePeriod,
      fetchDetailLoading: false
    }
  },
  components: {
    EditPatient
  },
  mounted: function() {
    this.getPatientProfile()
    this.timer = setInterval(this.getPatientProfile, 120000)
  },
  watch: {
    '$store.state.patient.selectedPatient.patientId': function() {
      this.getPatientProfile()
    }
  },
  methods: {
    getPatientProfile() {
      this.data = null
      if (!this.$store.state.patient.selectedPatient) return false
      this.loading = true
      ApiService.getPatientProfile(
        this.$store.state.patient.selectedPatient.patientId
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data
            if (this.data && this.data.patientProfile) {
              this.data.patientProfile = {
                ...this.data.patientProfile,
                DayStartTime: moment(
                  moment().format('YYYY-MM-DD ') +
                    this.data.patientProfile.DayStartTime
                ).format('h A'),
                DayEndTime: moment(
                  moment().format('YYYY-MM-DD ') +
                    this.data.patientProfile.DayEndTime
                ).format('h A'),
                NightStartTime: moment(
                  moment().format('YYYY-MM-DD ') +
                    this.data.patientProfile.NightStartTime
                ).format('h A'),
                NightEndTime: moment(
                  moment().format('YYYY-MM-DD ') +
                    this.data.patientProfile.NightEndTime
                ).format('h A')
              }
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    editPatient() {
      if (!this.$store.state.patient.selectedPatient) return false
      this.fetchDetailLoading = true
      ApiService.GetIndividualPatientDetail(
        this.$store.state.patient.selectedPatient.patientId
      )
        .then(response => {
          this.fetchDetailLoading = false
          if (response.data.success) {
            this.$refs.editPatient.openDialog()
            let detail = response.data.data
            detail = {
              ...detail,
              DayManufacturerId: detail.DayManufacturerId || '',
              DayProductId: detail.DayProductId || '',
              NightProductId: detail.NightProductId || '',
              NightManufacturerId: detail.NightManufacturerId || '',
              DayStartTime: detail.DayProductId ? detail.DayStartTime : '',
              DayEndTime: detail.DayProductId ? detail.DayEndTime : '',
              NightStartTime: detail.NightProductId
                ? detail.NightStartTime
                : '',
              NightEndTime: detail.NightProductId ? detail.NightEndTime : '',
              AllocatedPod: detail.AllocatedPod.substring(
                detail.AllocatedPod.length - 4
              )
            }
            this.$nextTick(() => {
              this.$refs.editPatient.isEdit = true
              this.$refs.editPatient.$refs.patientDetailSection.form = detail
              this.$refs.editPatient.$refs.patientBuildingSection.form = detail
              this.$refs.editPatient.$refs.patientDeviceSection.form = detail
              this.$refs.editPatient.$refs.patientProductsSection.form = detail
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.fetchDetailLoading = false
        })
    },
    refreshData() {
      this.getPatientProfile()
      this.$parent.getDetail()
      this.$parent.getPatientGoal()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
